import { render } from "./img_fixed.vue?vue&type=template&id=b789de34&scoped=true"
import script from "./img_fixed.vue?vue&type=script&lang=js"
export * from "./img_fixed.vue?vue&type=script&lang=js"

import "./img_fixed.vue?vue&type=style&index=0&id=b789de34&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b789de34"]])

export default __exports__